module.exports = __webpack_public_path__ + "img/17.2fb04c22.jpg";